// removed by extract-text-webpack-plugin
module.exports = {"container":"_3TJjA"};


//////////////////
// WEBPACK FOOTER
// ./app/components/layout/simple-layout.scss
// module id = 1291
// module chunks = 0